export const administrationAccountsDepartmentRscDetails = {
    template: require('./administration-accounts-department-rsc-details.html'),
    controller: 'AdministrationAccountsDepartmentRscDetailsController'
};
